export default {
  courses: [],
  banner_courses: [],
  my_list: [],
  masters: null,
  master: null,
  masterCourses: [],
  highlighted_categories: [],
  highlighted_categories_library: [],
  library_categories: [],
  conferences_highlighted: [],
  conference_categories: [],
  current_master: {},
  current_book: {},
  current_exam: {},

  course: null,

  started_courses: [],
  completed_courses: [],

  previewCourse: null,
  lessons: [],
  progress: {},
  course_progress: {},
  last_lessons: [],
  must_see_courses: [],
  recently_launched: [],
  conferences: [],
  teachers: [],
  library: [],
  ranked_courses: [],
  categories: [],
  category_courses_showing: [],
  coursesCollection: [],
  watched_courses: [],
};
